/* eslint-disable eqeqeq */
import { useState } from 'react';
import { Stack } from '@mui/material';
import TextMaxLine from '../../../components/TextMaxLine';
import { Item, ItemTypesEnum } from 'src/@types/Course';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ItemTypeForm from './StepOneForm';
import VideoItemForm from './course-section-forms/VideoItemForm';
import DocumentItemForm from './course-section-forms/DocumentItemForm';
import TextItemForm from './course-section-forms/TextItemForm';
import QuizItemForm from './course-section-forms/Quiz';

// ----------------------------------------------------------------------

type Props = {
  isEdit: boolean;
  currentItem?: Item | undefined;
  handleClose(): void;
  onSubmit(data: any,isDocument?:boolean): void;
  setModalStep(step: number): void;
  modalStep: number;
};

export default function NewSectionItemForm({
  isEdit,
  currentItem,
  handleClose,
  onSubmit,
  setModalStep,
  modalStep,
}: Props) {
  const [selectedType, setSelectedType] = useState<ItemTypesEnum | undefined>(
    currentItem ? currentItem.details?.type : undefined
  );

  return (
    <Stack height={'100%'} sx={{ overflow: 'auto' }}>
      {modalStep == 0 ? (
        <ItemTypeForm
          onSubmit={(data) => {
            setSelectedType(data?.type ?? ItemTypesEnum.TEXT);
            setModalStep(1);
          }}
        />
      ) : (
        <Stack>
          <Stack>
            <ArrowBackIcon
              sx={{
                color: '#000000',
                borderRadius: '50%',
                width: '25px',
                height: '25px',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (modalStep == 0) handleClose();
                else setModalStep(0);
              }}
            />
            <TextMaxLine marginBottom={'20px'} marginTop={'20px'} fontSize={'22px'}>
              {isEdit ? ` Edit ${selectedType} Item` : ` Create ${selectedType} Item`}
            </TextMaxLine>
          </Stack>
          {selectedType == ItemTypesEnum.VIDEO ? (
            <VideoItemForm
              currentItem={currentItem}
              onSubmit={(data) => {
                onSubmit(data);
                handleClose();
                setModalStep(0);
              }}
              key={'VideoForm'}
            />
          ) : selectedType == ItemTypesEnum.DOCUMENT ? (
            <DocumentItemForm
              currentItem={currentItem}
              onSubmit={(data) => {
                onSubmit(data,true);
                handleClose();
                setModalStep(0);
              }}
              key={'DocumentForm'}
            />
          ) : selectedType == ItemTypesEnum.TEXT ? (
            <TextItemForm
              currentItem={currentItem}
              onSubmit={(data: any) => {
                const newData = { ...data };
                delete newData.body;
                if (newData?.body_ar) delete newData?.body_ar;
                onSubmit({
                  ...newData,
                  details: {
                    ...data.details,
                    body: data.body,
                    body_ar: data.body_ar,
                  },
                });
                handleClose();
                setModalStep(0);
              }}
              key="ItemForm"
            />
          ) : selectedType == ItemTypesEnum.QUIZ ? (
            <QuizItemForm
              currentItem={currentItem}
              onSubmit={(data: any) => {
                // A quiz item's content is details.{type,questions} — no `body`
                // (that's the Text item). Close the modal on save like the
                // other item types do.
                onSubmit({ ...data, details: { ...data.details } });
                handleClose();
                setModalStep(0);
              }}
              key="ItemForm"
            />
          ) : (
            ''
          )}
        </Stack>
      )}
    </Stack>
  );
}
